import axios from "axios";
import { isUndefined } from "lodash";

const fetcher = (method, endpoint, data = null, authenticated = true, baseUrlPath = "") => {
  /*eslint-disable*/
  let url =
    baseUrlPath === ""
      ? environmentConfig?.ADMIN?.apiHost + environmentConfig?.ADMIN?.apiPath
      : environmentConfig[baseUrlPath].apiHost + environmentConfig[baseUrlPath].apiPath;
  /*eslint-enable*/

  const token = localStorage.getItem("qjumpers.publicui.auth.token") || null;
  let config = { method, url: `${url}${endpoint}`, responseType: "json" };
  if (authenticated) {
    if (!token) {
      // need to implement logout
      // keycloak.logout({ redirectUri: window.location.origin });
    }
    config.headers = { Authorization: `Bearer ${token}` };
  }

  if (data) {
    config.data = data;
  }

  return axios(config)
    .then((response) => {
      // implement token refresh
      return method === "get" ? response : { response, getUrl: url };
    })
    .catch((errorResponse) => {
      let { response: error } = errorResponse;
      const reloadCall = error?.config.url.split("/");

      if (isUndefined(error)) {
        error = errorResponse;
      }

      const { status, data } = error;

      sessionStorage.setItem("errorItem", "true");
      sessionStorage.setItem("status", status);

      if (reloadCall?.length && reloadCall[6] === "organisationsettings" && status === 400) {
        sessionStorage.setItem("reload", true);
      }

      if (data?.message) {
        sessionStorage.setItem("errorMsg", data.message);
      } else if (error?.statusText) {
        sessionStorage.setItem("errorMsg", error.statusText);
      }
      return new Error();
    });
};

export default fetcher;
